module.exports = __webpack_public_path__ + "static/media/BRA.1728fea5.png";